var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAwesomeUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.085,
    height: 14.76,
    viewBox: "0 0 21.085 14.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-users",
    "data-name": "Icon awesome-users",
    d: "M3.163,8.576A2.109,2.109,0,1,0,1.054,6.467,2.11,2.11,0,0,0,3.163,8.576Zm14.76,0a2.109,2.109,0,1,0-2.109-2.109A2.11,2.11,0,0,0,17.923,8.576ZM18.977,9.63H16.868a2.1,2.1,0,0,0-1.486.613,4.819,4.819,0,0,1,2.474,3.6h2.174a1.053,1.053,0,0,0,1.054-1.054V11.738A2.11,2.11,0,0,0,18.977,9.63Zm-8.434,0a3.69,3.69,0,1,0-3.69-3.69A3.688,3.688,0,0,0,10.543,9.63Zm2.53,1.054H12.8a5.095,5.095,0,0,1-4.514,0H8.012a3.8,3.8,0,0,0-3.8,3.8v.949A1.582,1.582,0,0,0,5.8,17.01h9.488a1.582,1.582,0,0,0,1.581-1.581V14.48A3.8,3.8,0,0,0,13.073,10.684ZM5.7,10.243A2.1,2.1,0,0,0,4.217,9.63H2.109A2.11,2.11,0,0,0,0,11.738v1.054a1.053,1.053,0,0,0,1.054,1.054H3.225A4.831,4.831,0,0,1,5.7,10.243Z",
    transform: "translate(0 -2.25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwesomeUsers);
export default __webpack_public_path__ + "static/media/awesome-users.79a179b9098fad1974fb3c46d4be07de.svg";
export { ForwardRef as ReactComponent };